import { deleteMasterLocationDetails, getAssignedUserLocations, getMasterLocationsList } from './actions/LocationMasterActions';
import { resetFiltersAndSorting, alertConfirmation  } from '../../../../actions/utilAction';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import PaginatorCustom from './../../../../components/paginationCustom';
//import LocationMasterOldModal from './location-master-modal_old';
import RaisedButton from 'material-ui/RaisedButton';
import { renderTextField } from './../../../../components/reduxFields';
import React from 'react';
import SortingCustom from '../../../../components/SortingCustom';
import SubString from 'add-ellipsis';
import Tooltip from '../../../../components/Tooltip';
import LocationMasterModal from './location-master-modal';


class LocationMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      locationId: null,
    };
    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };
    this.renderMasterLocationsList = this.renderMasterLocationsList.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  };

  componentWillMount() {
    this.loadData();
  };

  componentWillUnmount() {
    Alert.closeAll();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_masterLocation && nextProps.saved_masterLocation !== this.props.saved_masterLocation) {
      this.loadData();
      // this.props.getAssignedUserLocations(this.props.loginUserInfo.userID);
    }
    if (nextProps.deleted_masterLocation && this.props.deleted_masterLocation !== nextProps.deleted_masterLocation) {
      this.loadData();
      // this.props.getAssignedUserLocations(this.props.loginUserInfo.userID);
    }
  };

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { SearchText: this.filter.searchText },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getMasterLocationsList(searchObj);
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, locationId: null });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleSubmitSearch() {
    return false;
  }

  handleEditClick = (event, locationMasterObj) => {
    Alert.closeAll();
    this.setState({ open: true, locationId: locationMasterObj.id });

  };

  handleAlertClick = (event, id) => {
    this.props.deleteMasterLocationDetails(id);
    Alert.closeAll();
  };

  handleDeleteClick = (event, locationMasterObj) => {
    alertConfirmation('Once you click yes, all the staff and clients linked with this location will get effected. Are you sure you want to delete this location ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: locationMasterObj.id,
      },
    });
  };
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  };
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('LocationMasterForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }
  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  };

  renderMasterLocationsList(locationsList) {
    locationsList = locationsList || [];
    if (!locationsList.length) {
      return (
        <tr><td colSpan="5" className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</td></tr>
      );
    }
    return locationsList.map((obj, index) => {
      return (
        <tr key={index}>
          <td width="15%">{obj.locationName}</td>
          <td width="30%">
            {obj.locationDescription != null && obj.locationDescription.length > 0 ?
              <Tooltip Description={obj.locationDescription} />
              : null}
            {obj.locationDescription != null && obj.locationDescription.length > 25 ? SubString(obj.locationDescription, 25) : obj.locationDescription != null ? obj.locationDescription : 'N/A'}
          </td>
          <td width="15%">{obj.facilityType || '-'}</td>
          <td width="35%">{obj.address || '-'}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td width="10%">
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }

  render() {

    const { masterLocationsList } = this.props;
    let locationsList = (masterLocationsList && masterLocationsList.data) || [];
    let locationMeta = (masterLocationsList && masterLocationsList.meta) || null;

    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
      'suptable': true,
    });
    return (
      <div>
        {this.state.open ? <LocationMasterModal closeDialog={this.handleClose} locationId={this.state.locationId} /> : null}

        <h2 className="page_title">Manage Location</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className='row'>
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Location" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={this.props.handleSubmit(this.handleSubmitSearch)}>
                        <Field
                          name="Location"
                          floatingLabelText="Search"
                          maxLength='10'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn" onTouchTap={this.handleResetButton}>Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive mt-15">
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="15%"><SortingCustom noSort={!locationsList.length} setSortColumn={this.setSortColumn} columnName='LocationName' displayName='Location Name' /></th>
                          <th width="25%"><SortingCustom noSort={!locationsList.length} setSortColumn={this.setSortColumn} columnName='LocationDescription' displayName='Description' /></th>
                          <th width='15%'><SortingCustom noSort={!locationsList.length} setSortColumn={this.setSortColumn} columnName='FacilityCode' displayName='Facility Type' /></th>
                          <th width='30%'><SortingCustom noSort={!locationsList.length} setSortColumn={this.setSortColumn} columnName='Address' displayName='Address' /></th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="15%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderMasterLocationsList(locationsList)}
                      </tbody>
                    </table>
                  </div>
                  {locationMeta && locationMeta['totalPages'] ?
                    <PaginatorCustom data={locationMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {
  // console.log('state.location_master.......',state.location_master);
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_LOCATION_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_LOCATION_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_LOCATION_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_LOCATION_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    loading: state.location_master.loading,
    masterLocationsList: state.location_master.masterLocationsList,
    deleted_masterLocation: state.location_master.deleted_masterLocation,
    saved_masterLocation: state.location_master.saved_masterLocation,
    loginUserInfo: state.login.loginUserInfo,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
LocationMaster = reduxForm({
  form: 'LocationMasterForm',
})(LocationMaster);

export default connect(mapStateToProps, { deleteMasterLocationDetails, getMasterLocationsList, getAssignedUserLocations })(LocationMaster);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/location-master/location-master.js